var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHalfDarkHexagon = function SvgHalfDarkHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 94,
    fill: "none",
    viewBox: "0 0 117 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#half-dark-hexagon_svg__paint0_linear_733_10293)",
    strokeWidth: 8,
    d: "m142.558 61.562-29.007 62.675-68.782 6.216L4.994 73.994 34 11.32l68.783-6.216z",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "half-dark-hexagon_svg__paint0_linear_733_10293",
    x1: 151.239,
    x2: 82.662,
    y1: 158.967,
    y2: -46.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191A33",
    stopOpacity: 0
  })))));
};
export default SvgHalfDarkHexagon;